enum ProfileSettingsTypes {
  GetOrgAdminInfoRequest = 'profileSettings.GetOrgAdminInfoRequest',
  GetOrgAdminInfoSuccess = 'profileSettings.GetOrgAdminInfoSuccess',
  GetOrgAdminInfoFailure = 'profileSettings.GetOrgAdminInfoFailure',
  UpdateOrgAdminInfoRequest = 'profileSettings.UpdateOrgAdminInfoRequest',
  UpdateOrgAdminInfoSuccess = 'profileSettings.UpdateOrgAdminInfoSuccess',
  UpdateOrgAdminInfoFailure = 'profileSettings.UpdateOrgAdminInfoFailure',
  GetProfileInfoRequest = 'profileSettings.GetProfileInfoRequest',
  GetProfileInfoSuccess = 'profileSettings.GetProfileInfoSuccess',
  GetProfileInfoFailure = 'profileSettings.GetProfileInfoFailure',
  UpdateProfileInfoRequest = 'profileSettings.UpdateProfileInfoRequest',
  UpdateProfileInfoSuccess = 'profileSettings.UpdateProfileInfoSuccess',
  UpdateProfileInfoFailure = 'profileSettings.UpdateProfileInfoFailure',
  ResetPasswordRequest = 'profileSettings.ResetPasswordRequest',
  ResetPasswordSuccess = 'profileSettings.ResetPasswordSuccess',
  ResetPasswordFailure = 'profileSettings.ResetPasswordFailure',
}

export { ProfileSettingsTypes };
